import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./Feld.css";
/**
 * Ein beschriftetes Formularfeld mit zwei GRUNDVERSCHIEDENEN Darstellungen, nicht nur einer
 * abgeblendeten Variante derselben: Im Lesemodus (`bearbeitbar={false}`) steht der Wert als
 * reiner Text da, ganz ohne `<input>`. Ein deaktiviertes Eingabefeld sähe aus wie etwas, das
 * man ändern könnte, wenn man nur wüsste wie — und ein Bildschirmleser läse es trotzdem als
 * Formularfeld vor, obwohl es dort nichts zu tun gibt.
 *
 * Im Bearbeitungsmodus verknüpft ein `<label htmlFor>` Beschriftung und Eingabe, und ein
 * Fehler hängt zugänglich am Feld selbst (`aria-invalid` + `aria-describedby`), nicht nur
 * als roter Text daneben.
 */
export function Feld(p) {
    if (!p.bearbeitbar) {
        const angezeigterWert = p.wert.trim() === "" ? "—" : p.wert;
        return (_jsxs("div", { className: "ki-feld ki-feld--lesen", children: [_jsx("span", { className: "ki-feld__label", children: p.label }), _jsx("span", { className: "ki-feld__wert", children: angezeigterWert })] }));
    }
    const fehlerId = `${p.id}-fehler`;
    const hatFehler = p.fehler !== undefined;
    function beiAenderung(ereignis) {
        p.onChange(ereignis.target.value);
    }
    return (_jsxs("div", { className: hatFehler ? "ki-feld ki-feld--fehler" : "ki-feld", children: [_jsx("label", { htmlFor: p.id, className: "ki-feld__label", children: p.label }), _jsx("input", { id: p.id, type: p.typ ?? "text", className: "ki-feld__eingabe", value: p.wert, onChange: beiAenderung, autoComplete: p.autoComplete, "aria-invalid": hatFehler ? true : undefined, "aria-describedby": hatFehler ? fehlerId : undefined }), hatFehler && (_jsx("span", { id: fehlerId, className: "ki-feld__fehler", children: p.fehler }))] }));
}
//# sourceMappingURL=Feld.js.map